import type { ReactNode } from 'react';

// A screen: the bar along the top (title, then whatever goes on the right) and the content below it. The content is where the
// skip link sends the keyboard focus. (As in the Toolkit's shared/ui/Page.)
export function Page({ title, actions, children }: { title: ReactNode; actions?: ReactNode; children: ReactNode }) {
  return (
    <>
      <div className="topbar"><h2>{title}</h2>{actions && <><span className="grow" />{actions}</>}</div>
      <div className="content" id="content" tabIndex={-1}>{children}</div>
    </>
  );
}
